import { render, staticRenderFns } from "./index.vue?vue&type=template&id=bca08b18&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=bca08b18&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca08b18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bca08b18')) {
      api.createRecord('bca08b18', component.options)
    } else {
      api.reload('bca08b18', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=bca08b18&scoped=true", function () {
      api.rerender('bca08b18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/panel/enshrine/index.vue"
export default component.exports